import Main from "../components/layout/Main";
import React from "react";
import Projects from "../containers/CohortBuilder/Projects/Projects";

export const HealthCareUsageReportStudiesPage = () => {
    return <Main title="Healthcare Resource Utilisation"><Projects/></Main>
}